import { render, staticRenderFns } from "./GridRestaurantMenu.vue?vue&type=template&id=56a3839a&scoped=true&"
import script from "./GridRestaurantMenu.vue?vue&type=script&lang=js&"
export * from "./GridRestaurantMenu.vue?vue&type=script&lang=js&"
import style0 from "./GridRestaurantMenu.vue?vue&type=style&index=0&id=56a3839a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a3839a",
  null
  
)

export default component.exports